// Vendor
import classnames from 'classnames';
import * as React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

// Internal
import { DEFAULT_SAL_PROPS } from '@src/config/sal';

// Styles
import styles from './styles.module.css';

const getTopBrands = graphql`
  query getTopBrands {
    allTopBrandsPerBudgetJson {
      nodes {
        five {
          brand
          link
        }
        four {
          brand
          link
        }
        three {
          brand
          link
        }
        two {
          brand
          link
        }
      }
    }
  }
`;

const BrandsForEveryBudget: React.FC = () => {
  // Hooks
  const data = useStaticQuery<GatsbyTypes.getTopBrandsQuery>(getTopBrands);

  // Setup
  const node = data.allTopBrandsPerBudgetJson.nodes[0];
  const { five, four, three, two } = node;

  // Styles
  const classesFive = classnames(styles.column, styles.five);
  const classesFour = classnames(styles.column, styles.four);
  const classesThree = classnames(styles.column, styles.three);
  const classesTwo = classnames(styles.column, styles.two);

  // Markup
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const renderColumn = (item: any, index: number) => {
    const { brand, link } = item;
    const delay = index * 50;

    return (
      <li
        {...DEFAULT_SAL_PROPS}
        data-sal-delay={delay}
        key={`${brand}-${index}`}
      >
        <a href={link} target="_blank" rel="noopener noreferrer">
          {index + 1}. {brand}
        </a>
      </li>
    );
  };

  return (
    <div className="tup-slide">
      <h1 {...DEFAULT_SAL_PROPS}>Best Brand Buys for Every Budget</h1>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div {...DEFAULT_SAL_PROPS} data-sal-delay={50} className={classesFive}>
          <h3>$$$$$</h3>
          <ul>{five?.map(renderColumn)}</ul>
        </div>
        <div
          {...DEFAULT_SAL_PROPS}
          data-sal-delay={100}
          className={classesFour}
        >
          <h3>$$$$</h3>
          <ul>{four?.map(renderColumn)}</ul>
        </div>
        <div
          {...DEFAULT_SAL_PROPS}
          data-sal-delay={150}
          className={classesThree}
        >
          <h3>$$$</h3>
          <ul>{three?.map(renderColumn)}</ul>
        </div>
        <div {...DEFAULT_SAL_PROPS} data-sal-delay={200} className={classesTwo}>
          <h3>$$</h3>
          <ul>{two?.map(renderColumn)}</ul>
        </div>
      </div>
      <p
        {...DEFAULT_SAL_PROPS}
        data-sal-delay={250}
        className="tup-source text-center mt-8 max-w-2xl m-auto"
      >
        Resale Value Ranking: thredUP evaluated 35,000+ unique brands on its
        platform and created an aggregate score to determine a brand&apos;s
        ranking based on demand, virality, and value to the seller.
      </p>
    </div>
  );
};

export { BrandsForEveryBudget };
